import * as types from './constants';

// Get Help
export const getFaqRequest = data => (
  { type: types.GET_FAQ_REQUEST, payload: data }
);

export const getFaqDone = data => (
  { type: types.GET_FAQ_DONE, payload: data }
);

export const getFaqFailed = errors => (
  { type: types.GET_FAQ_FAILED, payload: errors }
);

// Get Definitions

export const getDefinitionsRequest = data => (
  { type: types.GET_DEFINITIONS_REQUEST, payload: data }
);

export const getDefinitionsDone = data => (
  { type: types.GET_DEFINITIONS_DONE, payload: data }
);

export const getDefinitionsFailed = errors => (
  { type: types.GET_DEFINITIONS_FAILED, payload: errors }
);